<div class="wm-form" *ngIf="liveWidgetSettingsService.activeTab.type === 'fields'" [ngClass]='{"disabled" : !liveWidgetSettingsService.selectedComponent.field.pcDisplay &&  !liveWidgetSettingsService.selectedComponent.field.mobileDisplay && !liveWidgetSettingsService.selectedComponent.field.isGroup}'>
  <p class="alert app-message alert-info" *ngIf="liveWidgetSettingsService.showActionMessage"><i class="icon"></i>
    <span *ngIf="liveWidgetSettingsService.showActionMessage">{{locale.MESSAGE_CUSTOM_SCRIPT_CREATED}}
      <a style='cursor:pointer' (click)='liveWidgetSettingsService.saveDesignerSettings(true)'> {{locale.LABEL_CLICK_HERE_TO_EDIT}}</a></span>
  </p>
  <div [hidden]="liveWidgetSettingsService.selectedComponent.field.isGroup" class="dialog-form-section">
    <div class="form-group app-composite-widget clearfix">
      <label class="col-md-3 control-label app-label">{{locale.LABEL_WIDGET_DESIGNER_BINDING_COLUMN}}</label>
      <label class="control-label app-label"
             *ngIf="!liveWidgetSettingsService.selectedComponent.field.allowBinding">{{liveWidgetSettingsService.selectedComponent.field.field || liveWidgetSettingsService.selectedComponent.field.key || 'none'}}</label>

      <div class="form-control wms-typeahead-live-filter"
           *ngIf="liveWidgetSettingsService.selectedComponent.field.allowBinding">
        <wms-typeahead name="wms-binding-column"
                       [editable]="true"
                       [ngClass]="{'invalid-input': liveWidgetSettingsService.selectedComponent.field.duplicateField}"
                       (onSelect)="liveWidgetSettingsService.onMappedFieldChange(liveWidgetSettingsService.selectedComponent.field, 'field', 'displayName', $event)"
                       [model]="liveWidgetSettingsService.selectedComponent.field.field"
                       [options]="fieldsList"
                       [modelType]="'string'"></wms-typeahead>
      </div>

      <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_BINDING_COLUMN}}"
         class="wms wms-help"></i>
      <p class="row help-block col-md-9 col-md-push-3"
         *ngIf="liveWidgetSettingsService.selectedComponent.field.duplicateField">{{locale.HELP_MESSAGE_WIDGET_DESIGNER_DUPLICATE_COLUMN}}</p>
    </div>

<!--sortBy-->

    <div class="form-group app-composite-widget clearfix" >
      <label class="col-md-3 control-label app-label">{{locale.LABEL_WIDGET_DESIGNER_BINDING_TARGET_COLUMN}}</label>

      <div class="form-control wms-typeahead-live-filter">
        <wms-typeahead name="wms-binding-column"
                       [editable]="true"
                       [ngClass]="{'invalid-input': liveWidgetSettingsService.selectedComponent.field.duplicateField}"
                       (onSelect)="liveWidgetSettingsService.setTragetColumn($event)"
                       [model]="liveWidgetSettingsService.selectedComponent.field.sortby"
                       [options]="fieldsList"
                       [modelType]="'string'"></wms-typeahead>
      </div>

      <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_BINDING_COLUMN}}"
         class="wms wms-help"></i>
      <p class="row help-block col-md-9 col-md-push-3"
         *ngIf="liveWidgetSettingsService.selectedComponent.field.duplicateField">{{locale.HELP_MESSAGE_WIDGET_DESIGNER_DUPLICATE_COLUMN}}</p>
    </div>

    <!--Type-->
    <div class="form-group app-composite-widget clearfix">
      <label class="col-md-3 control-label app-label">{{locale.LABEL_WIDGET_DESIGNER_COLUMN_TYPE}}</label>
      <label class="control-label app-label"
             *ngIf="!liveWidgetSettingsService.selectedComponent.field.allowBinding">{{liveWidgetSettingsService.selectedComponent.field.type || 'none'}}</label>
      <div class="form-control wms-typeahead-live-filter"
           *ngIf="liveWidgetSettingsService.selectedComponent.field.allowBinding">
        <wms-typeahead [placeholder]="locale.LABEL_WIDGET_DESIGNER_FIELD_TYPE" name="wms-live-type"
                       [model]="liveWidgetSettingsService.selectedComponent.field.type"
                       [options]="liveWidgetSettingsService.definedTypes"
                       [modelType]="'string'"
                       (onSelect)="liveWidgetSettingsService.onSelectedCompChange('field', 'type', $event);"
        ></wms-typeahead>
      </div>
      <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_COLUMN_TYPE}}"
         class="wms wms-help"></i>
    </div>
    <!--Title-->
    <div class="form-group app-composite-widget clearfix">
      <label class="col-md-3 control-label app-label">{{locale.LABEL_WIDGET_DESIGNER_TITLE}}</label>
      <input class="form-control app-textbox"
             [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.displayName"
             (ngModelChange)="onDisplayNameChange()"
             [ngModelOptions]="{ updateOn: 'blur' }"
             *ngIf="convertToString(liveWidgetSettingsService.selectedComponent.field.displayName).indexOf('bind:') !== 0"
             placeholder="{{locale.PLACEHOLDER_DESIGNER_COLUMN_TITLE}}" data-identifier="property-title"/>
      <div class="bind-input-wrapper"
           *ngIf="convertToString(liveWidgetSettingsService.selectedComponent.field.displayName).indexOf('bind:') === 0">
        <input type="text"
               class="form-control app-textbox bound-value bound-value-disable"
               [value]="liveWidgetSettingsService.selectedComponent.field.displayName"
               wmsExpressionError [expression]="liveWidgetSettingsService.selectedComponent.field.displayName"
               [attr.title]="liveWidgetSettingsService.selectedComponent.field.displayName"/>
        <button class="wm-icon clear wms wms-clear"
                (click)="liveWidgetSettingsService.clearBinding(liveWidgetSettingsService.selectedComponent.field, 'displayName')"></button>
      </div>
      <button name="wm-bind-property-displayName"
        (click)="liveWidgetSettingsService.openBindVariableDialog(liveWidgetSettingsService.selectedComponent ,'displayName', 'field')"
        [disabled]="liveWidgetSettingsService.activeWidgetScope.widgetProps['displayName']?.disabled"
        class="wms wms-link" title="{{locale['LABEL_BIND_VARIABLE']}}"></button>
      <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_TITLE}}"
         class="wms wms-help"></i>
    </div>
    <div class="form-group app-composite-widget clearfix">
      <label class="control-label property-label col-md-3">{{locale.LABEL_PROPERTY_SHOW}}</label>
      <wms-toggle [hideLabels]="true" [id]="'show'+'-'+liveWidgetSettingsService.selectedComponent.field.field"
                  *ngIf="convertToString(liveWidgetSettingsService.selectedComponent.field.show).indexOf('bind:') !== 0"
                  [model]="liveWidgetSettingsService.selectedComponent.field.show"
                  [onValue]="'true'"  [offValue]="'false'"
                  (onChange)="toToggle('show',$event)"
      ></wms-toggle>
            <div class="property-value bind-input-wrapper" *ngIf="convertToString(liveWidgetSettingsService.selectedComponent?.field.show).indexOf('bind:') === 0">
              <input type="text" class="form-control app-textbox bound-value bound-value-disable" [value]="liveWidgetSettingsService.selectedComponent.field.show" disabled
                     wmsExpressionError [expression]="liveWidgetSettingsService.selectedComponent.field.show"
                     [attr.title]="liveWidgetSettingsService.selectedComponent.field.show"/>
              <button class="wm-icon clear wms wms-clear" (click)="liveWidgetSettingsService.clearBinding(liveWidgetSettingsService.selectedComponent.field, 'show', true)"></button>
            </div>
      <button name="wm-bind-property-{{'show'}}"
              (click)="liveWidgetSettingsService.openBindVariableDialog(liveWidgetSettingsService.selectedComponent, 'show', 'field')"
              class="wms wms-link" title="{{locale.LABEL_BIND_VARIABLE}}"></button>
      <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_SHOW}}"
         class="wms wms-help"></i>
    </div>
    <!--enable cell editing-->
    <div class="form-group app-composite-widget clearfix"
         *ngIf="!liveWidgetSettingsService.activeWidgetScope.isGridPartOfLiveGrid">
      <label class="col-md-3 control-label app-label">{{locale.LABEL_WIDGET_DESIGNER_READONLY}}</label>
      <wms-toggle [hideLabels]="true" [id]="'readonly'+'-'+liveWidgetSettingsService.selectedComponent.field.field"
                  [model]="liveWidgetSettingsService.selectedComponent.field.readonly"
                  *ngIf="convertToString(liveWidgetSettingsService.selectedComponent.field.readonly).indexOf('bind:') !== 0"
                  [onValue]="'true'"  [offValue]="'false'"
                  (onChange)="toToggle('readonly',$event)"
      ></wms-toggle>
      <div class="property-value bind-input-wrapper" *ngIf="convertToString(liveWidgetSettingsService.selectedComponent?.field.readonly).indexOf('bind:') === 0">
              <input type="text" class="form-control app-textbox bound-value bound-value-disable" [value]="liveWidgetSettingsService.selectedComponent.field.readonly" disabled
                     wmsExpressionError [expression]="liveWidgetSettingsService.selectedComponent.field.readonly"
                     [attr.title]="liveWidgetSettingsService.selectedComponent.field.readonly"/>
              <button class="wm-icon clear wms wms-clear" (click)="liveWidgetSettingsService.clearBinding(liveWidgetSettingsService.selectedComponent.field, 'readonly', true)"></button>
            </div>
      <button name="wm-bind-property-{{'readonly'}}"
              (click)="liveWidgetSettingsService.openBindVariableDialog(liveWidgetSettingsService.selectedComponent, 'readonly', 'field')"
              class="wms wms-link" title="{{locale.LABEL_BIND_VARIABLE}}"></button>
      <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_READONLY}}"
         class="wms wms-help"></i>
    </div>
    <!-- enable sort -->
    <div class="form-group app-composite-widget clearfix" *ngIf="liveWidgetSettingsService.shadowProperties.enablesort">
      <label class="col-md-3 control-label app-label">{{locale.LABEL_WIDGET_DESIGNER_SORTABLE}}</label>
      <wms-toggle [hideLabels]="true" [id]="'sortable'+'-'+liveWidgetSettingsService.selectedComponent.field.field"
                  [model]="liveWidgetSettingsService.selectedComponent.field.sortable"
                  *ngIf="convertToString(liveWidgetSettingsService.selectedComponent.field.sortable).indexOf('bind:') !== 0"
                  (onChange)="toToggle('sortable',$event)"
                  [onValue]="undefined"  [offValue]="'false'"
      ></wms-toggle>
      <div class="property-value bind-input-wrapper" *ngIf="convertToString(liveWidgetSettingsService.selectedComponent?.field.sortable).indexOf('bind:') === 0">
              <input type="text" class="form-control app-textbox bound-value bound-value-disable" [value]="liveWidgetSettingsService.selectedComponent.field.sortable" disabled
                     wmsExpressionError [expression]="liveWidgetSettingsService.selectedComponent.field.sortable"
                     [attr.title]="liveWidgetSettingsService.selectedComponent.field.sortable"/>
              <button class="wm-icon clear wms wms-clear" (click)="liveWidgetSettingsService.clearBinding(liveWidgetSettingsService.selectedComponent.field, 'sortable', true)"></button>
            </div>
      <button name="wm-bind-property-{{'sortable'}}"
              (click)="liveWidgetSettingsService.openBindVariableDialog(liveWidgetSettingsService.selectedComponent, 'sortable', 'field')"
              class="wms wms-link" title="{{locale.LABEL_BIND_VARIABLE}}"></button>
      <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_SORTABLE}}"
         class="wms wms-help"></i>
    </div>

    <div class="form-group app-composite-widget clearfix" *ngIf="liveWidgetSettingsService.selectedComponent.field.sortable && checkVariableType()">
      <label class="col-md-3 control-label app-label">{{locale.LABEL_WIDGET_DESIGNER_CASEINSENSITIVE}}</label>
      <wms-toggle [hideLabels]="true" [id]="'caseinsensitive'+'-'+liveWidgetSettingsService.selectedComponent.field.field"
                  [model]="liveWidgetSettingsService.selectedComponent.field.caseinsensitive"
                  (onChange)="toToggle('caseinsensitive',$event)"
                  [onValue]="undefined"  [offValue]="'false'"
      ></wms-toggle>
      <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_CASEINSENSITIVE}}"
         class="wms wms-help"></i>
    </div>

    <!--Group-->
    <div class="form-group app-composite-widget clearfix">
      <label class="col-md-3 control-label app-label">{{locale.LABEL_WIDGET_DESIGNER_WIDGET_GROUP}}</label>
      <wms-typeahead class="col-md-5" name="wms-select-group"
                     [placeholder]="locale.MESSAGE_PLACEHOLDER_WIDGET_DESIGNER_WIDGET_GROUP"
                     [model]="liveWidgetSettingsService.selectedComponent.field.parentGroup"
                     [options]="groupList"
                     (onSelect)="changeGroups(liveWidgetSettingsService.selectedComponent.field?.parentGroup, $event)"
                     (onClear)="changeGroups(liveWidgetSettingsService.selectedComponent.field?.parentGroup, undefined)" propertyName="displayName"
                     model-property-name="object"></wms-typeahead>
      <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_GROUP}}"
         class="wms wms-help"></i>
    </div>

    <tabset class="inner-tabs">
      <!--View mode tab.-->
      <tab (selectTab)="liveWidgetSettingsService.selectPropertyGroup(liveWidgetSettingsService.propertyGroups[0]);"
           title=" {{locale.LABEL_GRID_DESIGNER_VIEW_OPTIONS}}"   style='padding-top:15px'>
        <ng-template tabHeading class="tab-heading">
          {{locale.LABEL_GRID_DESIGNER_VIEW_OPTIONS}}
        </ng-template>
        <ng-template [ngTemplateOutlet]="advancedTemplate"></ng-template>

        <h5 class="dialog-body-sub-heading" style="margin: 10px 0px">{{locale.LABEL_GRID_DESIGNER_DIALOG_SUBTITLE}}<i placement="left" [tooltipAppendToBody]="true"
                                                                                             tooltip="{{locale['MESSAGE_HELP_PROPERTY_FORMAT_OPTIONS']}}"
                                                                                             class="wm-icon wms wms-help"></i>
        </h5>
        <!--Format Type-->
        <div class="form-group app-composite-widget clearfix">
          <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_FORMATPATTERN}}</label>
          <select [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.formatpattern"
                  class="form-control app-select"
                  (change)="setCustomPipeConfigs(liveWidgetSettingsService.selectedComponent.field.formatpattern); updateFormatPatterns(liveWidgetSettingsService.selectedComponent.field.formatpattern);"
                  [disabled]="liveWidgetSettingsService.selectedComponent.field.customExpression"
                  [attr.title]="liveWidgetSettingsService.selectedComponent.field.customExpression ? locale.MESSAGE_HELP_PROPERTY_DISABLE_FORMATPATTERN : ''"
                  data-identifier="property-formattype">
            <optgroup label="">
              <option *ngFor="let value of formatPatterns " [hidden]="value === 'custom'" [value]="value">{{value}}</option>
            </optgroup>
            <ng-container>
              <optgroup label="Custom" *ngIf="!liveWidgetSettingsService.isPrefabType  && !liveWidgetSettingsService.isTemplateBundleType">
                <ng-container  *ngFor="let pipeOption of customPipeOptions | keyvalue">
                  <option *ngIf="pipesArr && pipesArr.length  && formatPatterns.indexOf(pipeOption.key) === -1"
                          [value]="pipeOption.key">{{pipeOption.key}}</option>
                </ng-container>
                <option value="custompipe">{{locale.MESSAGE_CUSTOM_PIPES_NOT_FOUND}}</option>
              </optgroup>
            </ng-container>

          </select>
          <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PROPERTY_FORMATPATTERN}}" class="wms wms-help"></i>
          <p
            class="row col-md-9 help-block">{{locale['MESSAGE_PROPERTY_FORMAT_' + liveWidgetSettingsService.selectedComponent.field.formatpattern?.toUpperCase()]}}</p>
        </div>
        <!--Date Format-->
        <div class="form-group app-composite-widget clearfix"
             *ngIf="liveWidgetSettingsService.selectedComponent.field.formatpattern === 'toDate'">
          <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_DATEPATTERN}}</label>
          <datalist id="datetimePatternsList">
            <option *ngFor="let pattern of datetimePatterns ">{{pattern}}</option>
          </datalist>
          <input class="form-control app-textbox"
                 [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.datepattern"
                 list="datetimePatternsList"
                 placeholder="{{locale.MESSAGE_PLACEHOLDER_DATE_PATTERN}}"/>
          <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PROPERTY_DATEPATTERN}}"
             class="wms wms-help"></i>
        </div>
        <!--Currency Symbols-->
        <div class="form-group app-composite-widget clearfix"
             *ngIf="liveWidgetSettingsService.selectedComponent.field.formatpattern === 'toCurrency'">
          <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_SYMBOL}}</label>
          <datalist id="formatter-currency">
            <option *ngFor="let currency of currencyPatterns">{{currency}}</option>
          </datalist>
          <div class="input-group currency-wrapper">
            <input class="form-control app-textbox" list="formatter-currency"
                   [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.currencypattern"
                   ng-model-options="{updateOn: 'blur'}"/>
            <span
              class="input-group-addon">{{CURRENCY_INFO[liveWidgetSettingsService.selectedComponent.field.currencypattern]?.symbol}}</span>
          </div>
          <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PROPERTY_SYMBOL}}"
             class="wms wms-help"></i>
        </div>
        <!--Fraction Size-->
        <div class="form-group app-composite-widget clearfix"
             *ngIf="liveWidgetSettingsService.selectedComponent.field.formatpattern === 'toCurrency' || liveWidgetSettingsService.selectedComponent.field.formatpattern === 'numberToString'">
          <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_FRACTION_SIZE}}</label>
          <input class="form-control app-textbox" [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.fractionsize"
                 placeholder="{{locale.LABEL_PROPERTY_FRACTION_SIZE}}" type="number"
                 ng-model-options="{getterSetter: true, updateOn: 'blur'}"/>
          <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PROPERTY_FRACTION_SIZE}}"
             class="wms wms-help"></i>
        </div>
        <!--Prefix-->
        <div class="form-group app-composite-widget clearfix"
             *ngIf="liveWidgetSettingsService.selectedComponent.field.formatpattern === 'suffix'">
          <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_SUFFIX}}</label>
          <input class="form-control app-textbox" [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.suffix"
                 placeholder="{{locale.LABEL_PROPERTY_SUFFIX}}"/>
          <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PROPERTY_SUFFIX}}"
             class="wms wms-help"></i>
        </div>
        <!--Suffix-->
        <div class="form-group app-composite-widget clearfix"
             *ngIf="liveWidgetSettingsService.selectedComponent.field.formatpattern === 'prefix'">
          <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_PREFIX}}</label>
          <input class="form-control app-textbox" [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.prefix"
                 placeholder="{{locale.LABEL_PROPERTY_PREFIX}}"/>
          <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PROPERTY_PREFIX}}"
             class="wms wms-help"></i>
        </div>
        <div
          *ngIf="customPipeOptions && customPipeOptions[liveWidgetSettingsService.selectedComponent.field.formatpattern] && customPipeOptions[liveWidgetSettingsService.selectedComponent.field.formatpattern].config">
          <div class="form-group app-composite-widget clearfix"
               *ngFor="let pipeOption of customPipeOptions[liveWidgetSettingsService.selectedComponent.field.formatpattern].config |keyvalue">

            <datalist
              *ngIf="customPipeOptions[liveWidgetSettingsService.selectedComponent.field.formatpattern].config[$any(pipeOption.key)].options && customPipeOptions[liveWidgetSettingsService.selectedComponent.field.formatpattern].config[$any(pipeOption.key)].options"
              id="formatter-custompipe">
              <option
                *ngFor="let option of customPipeOptions[liveWidgetSettingsService.selectedComponent.field.formatpattern].config[$any(pipeOption.key)].options">{{option}}</option>
            </datalist>

            <label class="col-md-3 control-label app-label"
                   [for]="customPipeOptions[liveWidgetSettingsService.selectedComponent.field.formatpattern].config[$any(pipeOption.key)].name">
              {{customPipeOptions[liveWidgetSettingsService.selectedComponent.field.formatpattern].config[$any(pipeOption.key)].name}}</label>
            <input
              [attr.list]="customPipeOptions[liveWidgetSettingsService.selectedComponent.field.formatpattern].config[$any(pipeOption.key)].widget == 'select' ? 'formatter-custompipe' : ''"
              class="form-control app-textbox"
              [id]="customPipeOptions[liveWidgetSettingsService.selectedComponent.field.formatpattern].config[$any(pipeOption.key)].name"
              type="text"
              (change)="updateFormatPatterns(liveWidgetSettingsService.selectedComponent.field.formatpattern);"
              [(ngModel)]="liveWidgetSettingsService.selectedComponent.field[customPipeOptions[liveWidgetSettingsService.selectedComponent.field.formatpattern].config[$any(pipeOption.key)].name]"/>
          </div>
        </div>


      </tab>
          <!--Edit mode tab.-->
      <tab (selectTab)="liveWidgetSettingsService?.selectPropertyGroup(liveWidgetSettingsService?.propertyGroups[0]);"  [customClass]="!(!liveWidgetSettingsService.activeWidgetScope.isPartOfLiveGrid && !liveWidgetSettingsService.selectedComponent?.field.readonly) ? 'hidden': ''"
           style='padding-top:15px'>
        <ng-template tabHeading class="tab-heading">
          {{locale.LABEL_GRID_DESIGNER_EDIT_OPTIONS}}
        </ng-template>

        <div class="form-group app-composite-widget clearfix">
          <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_WIDGET}}</label>
          <select class="form-control app-select" scopedataset="editableWidgetOptions"
                  [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.editWidgetType"
                  (ngModelChange)="widgetChanges(liveWidgetSettingsService.selectedComponent.field.editWidgetType)">
            <option [ngValue]="undefined"  [innerText]="locale.MESSAGE_PLACEHOLDER_WIDGET_TYPE_FOR_FIELD" ></option>
            <option *ngFor="let option of editableWidgetOptions" [value]="option">{{option}}</option>
          </select>
          <i placement="right"  [tooltipAppendToBody]="true" tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_WIDGET}}" class="wms wms-help"></i>
          <p class="row help-block col-md-9 col-md-push-3"
             *ngIf="locale['HELP_MESSAGE_WIDGET_DESIGNER_WIDGET_' + liveWidgetSettingsService.selectedComponent.field.editWidgetType?.toUpperCase()]"
             [innerHTML]="locale['HELP_MESSAGE_WIDGET_DESIGNER_WIDGET_' + liveWidgetSettingsService.selectedComponent.field.editWidgetType?.toUpperCase()]"></p>
        </div>


        <div class="form-group app-composite-widget clearfix" *ngIf="liveWidgetSettingsService.selectedComponent.field.editWidgetType === 'text'">
          <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_INPUTTYPE}}</label>
          <select class="form-control app-select" scopedataset="textInputTypeOptions"
                  [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.editinputtype">
            <option *ngFor="let option of textInputTypeOptions" [value]="option">{{option}}</option>
          </select>
          <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PROPERTY_INPUTTYPE}}"
             class="wms wms-help"></i>
        </div>

        <div class="form-group app-composite-widget clearfix"
             *ngIf="liveWidgetSettingsService.selectedComponent.field.editWidgetType && liveWidgetSettingsService.selectedComponent.field.editWidgetType !== 'Widget type for the field' && liveWidgetSettingsService.selectedComponent.field.editWidgetType !== 'checkbox' && liveWidgetSettingsService.selectedComponent.field.editWidgetType !== 'upload' && liveWidgetSettingsService.selectedComponent.field.editWidgetType !== 'toggle' && liveWidgetSettingsService.selectedComponent.field.editWidgetType !== 'slider' && liveWidgetSettingsService.selectedComponent.field.editWidgetType !== 'rating'">
          <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_PLACEHOLDER}}</label>
          <input class="form-control app-textbox"
                 [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.placeholder"
                 placeholder="{{locale.MESSAGE_PLACEHOLDER_GRID_DESIGNER_EDIT_OPTIONS}}"
                 ng-model-options="{ updateOn: 'blur change'}"
                 *ngIf="convertToString(liveWidgetSettingsService.selectedComponent.field.placeholder).indexOf('bind:') !== 0"/>
          <div class="bind-input-wrapper"
               *ngIf="convertToString(liveWidgetSettingsService.selectedComponent.field.placeholder).indexOf('bind:') === 0">
            <input type="text"
                   class="form-control app-textbox bound-value bound-value-disable" disabled
                   [value]="liveWidgetSettingsService.selectedComponent.field.placeholder"
                   wmsExpressionError [expression]="liveWidgetSettingsService.selectedComponent.field.placeholder"
                   [attr.title]="liveWidgetSettingsService.selectedComponent.field.placeholder"/>
            <button class="wm-icon clear wms wms-clear"
                    (click)="liveWidgetSettingsService.clearBinding(liveWidgetSettingsService.selectedComponent.field, 'placeholder')"></button>
          </div>
          <button name="wm-bind-property-placeholder"
            (click)="liveWidgetSettingsService.openBindVariableDialog(liveWidgetSettingsService.selectedComponent ,'placeholder', 'field')"
            [disabled]="liveWidgetSettingsService.activeWidgetScope.widgetProps['placeholder']?.disabled"
            class="wms wms-link" title="{{locale['LABEL_BIND_VARIABLE']}}"></button>
          <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PROPERTY_PLACEHOLDER}}"
             class="wms wms-help"></i>
        </div>

        <div
          *ngIf="liveWidgetSettingsService.isDatasetWidgets[liveWidgetSettingsService.selectedComponent.field.editWidgetType]">
          <div class="form-group app-composite-widget clearfix">
            <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTYGROUP_DATASET}}</label>
            <input class="form-control app-textbox" [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.dataset"
                   placeholder="Enter text"
                   *ngIf="convertToString(liveWidgetSettingsService.selectedComponent.field.dataset).indexOf('bind:') !== 0">
                        <div class="bind-input-wrapper" *ngIf="convertToString(liveWidgetSettingsService.selectedComponent.field.dataset).indexOf('bind:') === 0">
                          <input type="text" class="form-control app-textbox bound-value bound-value-disable" disabled value="{{liveWidgetSettingsService.selectedComponent.field.dataset}}"
                                 wmsExpressionError [expression]="liveWidgetSettingsService.selectedComponent.field.dataset"
                                 [attr.title]="liveWidgetSettingsService.selectedComponent.field.dataset"/>
                          <button class="wm-icon clear wms wms-clear" (click)="liveWidgetSettingsService.clearBinding(liveWidgetSettingsService.selectedComponent.field, 'dataset')"></button>
                        </div>
            <button  name="wm-bind-property-dataset"
              (click)="liveWidgetSettingsService.openBindVariableDialog(liveWidgetSettingsService.selectedComponent, 'dataset', 'field')"
              class="wms wms-link" title="{{locale['LABEL_BIND_VARIABLE']}}"></button>
            <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PROPERTY_DATASET}}"
               class="wms wms-help"></i>
          </div>


          <!--Datafield, display field and search key-->
          <div *ngIf="liveWidgetSettingsService.selectedComponent.field.dataset || liveWidgetSettingsService.displayfieldArray?.length">
            <div class="form-group app-composite-widget clearfix"
                 *ngIf="liveWidgetSettingsService.selectedComponent.field.editWidgetType === 'autocomplete'">
              <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_DISPLAYLABEL}}</label>
              <select class="form-control app-select" scopedataset="displayfieldArray"
                      [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.displaylabel">
                <option *ngFor=" let option of displayfieldArray" [value]="option"> {{option}}</option>
              </select>
              <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PROPERTY_DISPLAYLABEL}}"
                 class="wms wms-help"></i>
            </div>
            <div class="form-group app-composite-widget clearfix"
                 *ngIf="liveWidgetSettingsService.selectedComponent.field.editWidgetType === 'autocomplete'">
              <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_SEARCHKEY}}</label>
              <wm-checkboxset [datavalue]="liveWidgetSettingsService.selectedComponent.field.searchkey"
                              [dataset]="displayfieldArray"
                              (onChange)="handelChangesSearchKey($event.value)"
              ></wm-checkboxset>
              <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PROPERTY_SEARCHKEY}}"
                 class="wms wms-help"></i>
            </div>
            <div class="form-group app-composite-widget clearfix"
                 *ngIf="liveWidgetSettingsService.selectedComponent.field.editWidgetType === 'autocomplete'"
                 [hidden]="!liveWidgetSettingsService.selectedComponent.field.matchmodeShow">
              <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_MATCHMODE}}</label>
              <select class="form-control app-select" [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.matchmode"
                      scopedataset="matchModes">
                <option *ngFor=" let option of liveWidgetSettingsService.matchModes |keyvalue"
                        [value]="option.key"> {{option.value}}</option>
              </select>
              <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PROPERTY_MATCHMODE}}"
                 class="wms wms-help"></i>
            </div>
            <div class="form-group app-composite-widget clearfix">
              <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_DATAFIELD}}</label>
              <select class="form-control app-select" scopedataset="datafieldArray"
                      [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.datafield">
                <option *ngFor=" let option of datafieldArray;" [value]="option"> {{option}}</option>
              </select>
              <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PROPERTY_DATAFIELD}}"
                 class="wms wms-help"></i>
            </div>
            <div class="form-group app-composite-widget clearfix"
                 *ngIf="liveWidgetSettingsService.selectedComponent.field.editWidgetType !== 'autocomplete'">
              <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_DISPLAYFIELD}}</label>
              <select class="form-control app-select" scopedataset="displayfieldArray"
                      [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.displayfield">
                <option *ngFor=" let option of displayfieldArray;" [value]="option"> {{option}}</option>
              </select>
              <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PROPERTY_DISPLAYFIELD}}"
                 class="wms wms-help"></i>
            </div>
            <!--groupby-->
            <div class="form-group app-composite-widget clearfix">
              <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_GROUPBY}}</label>
              <div class="form-control wms-typeahead-live-filter">
                <wms-typeahead [placeholder]="locale.LABEL_PROPERTY_GROUPBY"
                               name="wms-select-group"
                               propertyName="name"
                               [model]="liveWidgetSettingsService.selectedComponent.field.groupby"
                               [options]="groupbyDisplayOptions"
                               (onSelect)="showOrHideMatch($event)"
                               (onClear)="liveWidgetSettingsService.onClear()"
                               groupBy="category"
                               model-property-name="name">
                </wms-typeahead>
              </div>
              <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PROPERTY_GROUPBY}}"
                 class="wms wms-help"></i>
              <p class="alert app-message alert-info" *ngIf="liveWidgetSettingsService.showGroupByActionMessage"><i
                class="icon"></i>
                <span
                  *ngIf="liveWidgetSettingsService.showGroupByActionMessage">{{locale.MESSAGE_CUSTOM_SCRIPT_CREATED}}<a
                  style='cursor:pointer'
                  (click)='liveWidgetSettingsService.saveDesignerSettings(true)'> {{locale.LABEL_CLICK_HERE_TO_EDIT}}</a></span>
              </p>
            </div>
            <!--group as-->
            <div class="form-group app-composite-widget clearfix"  *ngIf="liveWidgetSettingsService.selectedComponent.field.showMatch">
              <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_MATCH}}</label>
              <select class="form-control app-select"
                      role="input"
                      (change)="liveWidgetSettingsService.showOrHideDateformatProperty()"
                      [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.match">
                <option [value]="">{{locale.LABEL_PROPERTY_MATCH}}</option>
                <option value="{{nonGroupOpt.value}}"
                        *ngFor="let nonGroupOpt of liveWidgetSettingsService.timeNonGroupOptions ">{{locale[nonGroupOpt.labelkey]}}</option>
                <optgroup label="{{locale.LABEL_TIME}}"
                          *ngFor="let optVal of liveWidgetSettingsService.timeGroupOptions ">
                  <option [value]="optGroup.key"
                          *ngFor="let optGroup of optVal.groupOptions | keyvalue  ">{{optGroup.key}}</option>
                </optgroup>
              </select>
              <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PROPERTY_MATCH}}"
                 class="wms wms-help"></i>
            </div>
            <!--dateformat-->
            <div class="form-group app-composite-widget clearfix"
                 *ngIf="liveWidgetSettingsService.selectedComponent.field.showDateFormat">
              <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_DATEFORMAT}}</label>
              <datalist id="datePatternsList">
                <option *ngFor="let pattern of liveWidgetSettingsService.datePatterns | keyvalue | orderBy:'value' ">{{pattern.value}}</option>
              </datalist>
              <input class="form-control app-textbox"
                     [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.dateformat" list="datePatternsList"
                     placeholder="{{locale.MESSAGE_PLACEHOLDER_PATTERN}}"/>

              <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PROPERTY_DATEFORMAT}}"
                 class="wms wms-help"></i>
            </div>
            <!-- collapsible-->
            <div class="form-group app-composite-widget clearfix"
                 *ngIf="liveWidgetSettingsService.selectedComponent.field.showCollapsible">
              <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_COLLAPSIBLE}}</label>
              <wms-toggle [hideLabels]="true"
                          [id]="'collapsible'+'-'+liveWidgetSettingsService.selectedComponent.field.showCollapsible"
                          (onChange)="toToggle('collapsible',$event)"
                          [model]="liveWidgetSettingsService.selectedComponent.field.collapsible"></wms-toggle>
              <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PROPERTY_COLLAPSIBLE}}"
                 class="wms wms-help"></i>
            </div>
            <!--show count-->
            <div class="form-group app-composite-widget clearfix"
                 *ngIf="liveWidgetSettingsService.selectedComponent.field.showCount">
              <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_SHOWCOUNT}}</label>
              <wms-toggle [hideLabels]="true"
                          [id]="'showcount'+'-'+liveWidgetSettingsService.selectedComponent.field.showCount"
                          (onChange)="toToggle('showcount',$event)"
                          [model]="liveWidgetSettingsService.selectedComponent.field.showcount"></wms-toggle>
              <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PROPERTY_SHOWCOUNT}}"
                 class="wms wms-help"></i>
            </div>
          </div>
          <!--Limit on data-->
          <div class="form-group app-composite-widget clearfix"
               *ngIf="!liveWidgetSettingsService.selectedComponent.field.dataset">
            <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_LIMIT}}</label>
            <input class="form-control app-textbox" type="number"
                   [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.limit"
                   ng-model-options="{ updateOn: 'blur change'}">
            <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PROPERTY_LIMIT}}"
               class="wms wms-help"></i>
          </div>


        </div>

        <div class="form-group app-composite-widget clearfix"
             *ngIf="liveWidgetSettingsService.selectedComponent.field.editWidgetType && liveWidgetSettingsService.selectedComponent.field.editWidgetType !== 'upload' && liveWidgetSettingsService.selectedComponent.field.editWidgetType !== 'Widget type for the field' ">
          <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTYGROUP_VALUES}}</label>
          <div [ngSwitch]="liveWidgetSettingsService.selectedComponent.field.editWidgetType"
               *ngIf="convertToString(liveWidgetSettingsService.selectedComponent.field.defaultvalue).indexOf('bind:') !== 0"
               class="bind-wrapper">
            <ng-container *ngSwitchCase="'number'">
              <input class="form-control app-textbox"
                     [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.defaultvalue"
                     placeholder="{{locale.MESSAGE_PLACEHOLDER_VALUE_FOR_FIELD}}" type="number">
            </ng-container>
            <ng-container *ngSwitchCase="'date'">
              <input class="form-control app-textbox"
                     [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.defaultvalue"
                     placeholder="{{locale.MESSAGE_PLACEHOLDER_DEFAULT_VALUE}}" type="date">
            </ng-container>
            <ng-container *ngSwitchCase="'time'">
              <input class="form-control app-textbox"
                     [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.defaultvalue"
                     placeholder="{{locale.MESSAGE_PLACEHOLDER_DEFAULT_VALUE}}" type="time">
            </ng-container>
            <ng-container *ngSwitchCase="'datetime'">
              <input class="form-control app-textbox"
                     [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.defaultvalue"
                     placeholder="{{locale.MESSAGE_PLACEHOLDER_DEFAULT_VALUE}}" type="datetime-local">
            </ng-container>
            <ng-container *ngSwitchCase="'timestamp'">
              <input class="form-control app-textbox"
                     [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.defaultvalue"
                     placeholder="{{locale.MESSAGE_PLACEHOLDER_DEFAULT_VALUE}}" type="datetime-local">
            </ng-container>
            <ng-container *ngSwitchDefault>
              <input class="form-control app-textbox"
                     [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.defaultvalue"
                     placeholder="{{locale.MESSAGE_PLACEHOLDER_VALUE_FOR_FIELD}}" type="text">
            </ng-container>
          </div>
                      <div class="bind-input-wrapper" *ngIf="convertToString(liveWidgetSettingsService.selectedComponent.field.defaultvalue).indexOf('bind:') === 0">
                        <input type="text" class="form-control app-textbox bound-value bound-value-disable" disabled [value]="liveWidgetSettingsService.selectedComponent.field.defaultvalue"
                               wmsExpressionError [expression]="liveWidgetSettingsService.selectedComponent.field.defaultvalue"
                               [attr.title]="liveWidgetSettingsService.selectedComponent.field.defaultvalue"/>
                        <button class="wm-icon clear wms wms-clear" (click)="liveWidgetSettingsService.clearBinding(liveWidgetSettingsService.selectedComponent.field, 'defaultvalue')"></button>
                      </div>
          <button name="wm-bind-property-defaultvalue"
            (click)="liveWidgetSettingsService.openBindVariableDialog(liveWidgetSettingsService.selectedComponent, 'defaultvalue', 'field')"
            class="wms wms-link" title="{{locale['LABEL_BIND_VARIABLE']}}"></button>
          <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PROPERTY_DATAVALUE}}"
             class="wms wms-help"></i>
        </div>

        <!--ColorPicker Autoclose-->
        <div class="form-group app-composite-widget clearfix"
             *ngIf="liveWidgetSettingsService.selectedComponent.field.editWidgetType === 'colorpicker'">
          <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_AUTOCLOSE}}</label>
          <select class="form-control app-select" [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.autoclose">
            <option *ngFor="let option of liveWidgetSettingsService.autoCloseOptions" [value]="option.value">{{option.label}}</option>
          </select>
          <i placement="right" [tooltipAppendToBody]="true"   tooltip="{{locale['MESSAGE_HELP_PROPERTY_WM-COLORPICKER_AUTOCLOSE']}}"
             class="wms wms-help"></i>
        </div>
        <!--Date Format-->
        <div class="form-group app-composite-widget clearfix"
             *ngIf="liveWidgetSettingsService.isDateTimeType(liveWidgetSettingsService.selectedComponent.field.editWidgetType)">
          <label
            class="col-md-3 control-label app-label">{{liveWidgetSettingsService.selectedComponent.field.editWidgetType === 'time' ? locale.LABEL_PROPERTY_TIMEPATTERN : locale.LABEL_PROPERTY_DATEPATTERN}}</label>
          <datalist id="patternsList">
            <ng-container
              *ngIf="liveWidgetSettingsService.selectedComponent.field.editWidgetType === 'timestamp' || liveWidgetSettingsService.selectedComponent.field.editWidgetType === 'datetime'">
              <option *ngFor="let pattern of datetimePatterns   | keyvalue | orderBy:'value' ">{{pattern.value}}</option>
            </ng-container>
            <ng-container *ngIf="liveWidgetSettingsService.selectedComponent.field.editWidgetType === 'date'">
              <option *ngFor="let pattern of liveWidgetSettingsService.datePatterns  | keyvalue | orderBy:'value' ">{{pattern.value}}</option>
            </ng-container>
            <ng-container *ngIf="liveWidgetSettingsService.selectedComponent.field.editWidgetType === 'time'">
              <option *ngFor="let pattern of timePatterns  | keyvalue | orderBy:'value' ">{{pattern.value}}</option>
            </ng-container>

          </datalist>
          <input class="form-control app-textbox"
                 [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.editdatepattern" list="patternsList"
                 placeholder="{{locale.MESSAGE_PLACEHOLDER_PATTERN}}"/>
          <i placement="right" [tooltipAppendToBody]="true"
             tooltip="{{liveWidgetSettingsService.selectedComponent.field.editWidgetType === 'time' ? locale.MESSAGE_HELP_PROPERTY_TIMEPATTERN : locale.MESSAGE_HELP_PROPERTY_DATEPATTERN}}"
             class="wms wms-help"></i>
        </div>
        <!--Ouput Format-->
        <div class="form-group app-composite-widget clearfix"
             *ngIf="liveWidgetSettingsService.selectedComponent.field.editWidgetType === 'datetime'">
          <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_OUTPUTFORMAT}}</label>
          <datalist id="outpuFormatPattrenList">
            <option *ngFor="let pattern of liveWidgetSettingsService.datePatterns | keyvalue | orderBy:'value' ">{{pattern.value}}</option>
          </datalist>
          <input class="form-control app-textbox"
                 [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.outputformat" list="outpuFormatPattrenList"
                 placeholder="{{locale.MESSAGE_PLACEHOLDER_PATTERN}}"/>
          <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PROPERTY_OUTPUTFORMAT}}"
             class="wms wms-help"></i>
        </div>
        <!--Checked value.-->
        <div class="form-group app-composite-widget clearfix"
             *ngIf="liveWidgetSettingsService.selectedComponent.field.editWidgetType === 'checkbox' || liveWidgetSettingsService.selectedComponent.field.editWidgetType === 'toggle'">
          <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_CHECKEDVALUE}}</label>
          <input class="form-control app-textbox"
                 [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.checkedvalue"
                 ng-model-options="{ updateOn: 'blur change'}"/>
          <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PROPERTY_CHECKEDVALUE}}"
             class="wms wms-help"></i>
        </div>
        <!--Un Checked value.-->
        <div class="form-group app-composite-widget clearfix"
             *ngIf="liveWidgetSettingsService.selectedComponent.field.editWidgetType === 'checkbox' || liveWidgetSettingsService.selectedComponent.field.editWidgetType === 'toggle'">
          <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_UNCHECKEDVALUE}}</label>
          <input class="form-control app-textbox"
                 [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.uncheckedvalue"
                 ng-model-options="{ updateOn: 'blur change'}"/>
          <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PROPERTY_UNCHECKEDVALUE}}"
             class="wms wms-help"></i>
        </div>

        <!--Show Dropdown on -->
        <div class="form-group app-composite-widget clearfix"
             *ngIf="liveWidgetSettingsService.selectedComponent.field.editWidgetType === 'date' || liveWidgetSettingsService.selectedComponent.field.editWidgetType === 'datetime' || liveWidgetSettingsService.selectedComponent.field.editWidgetType === 'time' || liveWidgetSettingsService.selectedComponent.field.editWidgetType === 'timestamp'">
          <label
            class="col-md-3 control-label app-label">{{locale["LABEL_WIDGET_PROPERTY"]['wm-' + liveWidgetSettingsService.selectedComponent.field.editWidgetType]["SHOWDROPDOWNON"]}}</label>
          <select class="form-control app-select" scopedataset="showdateandtimePickerOptions" datafield="value"
                  displayfield="label" [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.showdropdownon">
            <option
              *ngFor="let option of liveWidgetSettingsService.showdateandtimePickerOptions ;"  [value]="option.value">{{option.label}}</option>
          </select>
          <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PROPERTY_SHOWDROPDOWNON}}"
             class="wms wms-help"></i>
        </div>
        <!--Data Entry Mode -->
        <div class="form-group app-composite-widget clearfix"
             *ngIf="liveWidgetSettingsService.selectedComponent.field.editWidgetType === 'date' || liveWidgetSettingsService.selectedComponent.field.editWidgetType === 'datetime' || liveWidgetSettingsService.selectedComponent.field.editWidgetType === 'time' || liveWidgetSettingsService.selectedComponent.field.editWidgetType === 'timestamp'">
          <label
            class="col-md-3 control-label app-label">{{locale["LABEL_WIDGET_PROPERTY"]['wm-' + liveWidgetSettingsService.selectedComponent.field.editWidgetType]["DATAENTRYMODE"]}}</label>
          <select class="form-control app-select" scopedataset="showDataEntryModeOptions" datafield="value"
                  displayfield="label" [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.dataentrymode">
            <option *ngFor="let option of liveWidgetSettingsService.showDataEntryModeOptions"  [value]="option.value" >{{option.label}}</option>
          </select>
          <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PROPERTY_DATAENTRYMODE}}"
             class="wms wms-help"></i>
        </div>
        <!--disabled-->
        <div class="form-group app-composite-widget clearfix"
             *ngIf="liveWidgetSettingsService.selectedComponent.field.editWidgetType && liveWidgetSettingsService.selectedComponent.field.editWidgetType !== 'upload'  && liveWidgetSettingsService.selectedComponent.field.editWidgetType !== 'Widget type for the field' ">
          <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_DISABLED}}</label>
          <wms-toggle [hideLabels]="true"
                      [id]="'disabled'+'--'+liveWidgetSettingsService.selectedComponent.field.disabled"
                      *ngIf="convertToString(liveWidgetSettingsService.selectedComponent.field.disabled).indexOf('bind:') !== 0"
                      [model]="liveWidgetSettingsService.selectedComponent.field.disabled"
                      (onChange)="toToggle('disabled',$event)"
          ></wms-toggle>
          <div class="property-value bind-input-wrapper"
               *ngIf="convertToString(liveWidgetSettingsService.selectedComponent.field.disabled).indexOf('bind:') === 0">
            <input type="text"
                   class="form-control app-textbox bound-value bound-value-disable"
                   [value]="liveWidgetSettingsService.selectedComponent.field.disabled" disabled
                   wmsExpressionError [expression]="liveWidgetSettingsService.selectedComponent.field.disabled"
                   [attr.title]="liveWidgetSettingsService.selectedComponent.field.disabled"/>
            <button class="wm-icon clear wms wms-clear"
                    (click)="liveWidgetSettingsService.clearBinding(liveWidgetSettingsService.selectedComponent.field, 'disabled')"></button>
          </div>
          <button name="wm-bind-property-{{'disabled'}}"
                  (click)="liveWidgetSettingsService.openBindVariableDialog(liveWidgetSettingsService.selectedComponent, 'disabled', 'field')"
                  class="wms wms-link" title="{{locale.LABEL_BIND_VARIABLE}}"></button>
          <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PROPERTY_DISABLED}}"
             class="wms wms-help"></i>
        </div>
        <!-- Show in edit mode-->
        <div class="form-group app-composite-widget clearfix">
          <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_SHOW}}</label>
          <wms-toggle [hideLabels]="true" [id]="'showineditmode'+'-'+liveWidgetSettingsService.selectedComponent.field.field"
                      *ngIf="convertToString(liveWidgetSettingsService.selectedComponent.field.showineditmode).indexOf('bind:') !== 0"
                      [model]="liveWidgetSettingsService.selectedComponent.field.showineditmode"
                      [onValue]="'true'"  [offValue]="'false'"
                      (onChange)="toToggle('showineditmode',$event)"
          ></wms-toggle>
          <div class="property-value bind-input-wrapper" *ngIf="convertToString(liveWidgetSettingsService.selectedComponent?.field.showineditmode).indexOf('bind:') === 0">
            <input type="text" class="form-control app-textbox bound-value bound-value-disable" [value]="liveWidgetSettingsService.selectedComponent.field.showineditmode" disabled
                   wmsExpressionError [expression]="liveWidgetSettingsService.selectedComponent.field.showineditmode"
                   [attr.title]="liveWidgetSettingsService.selectedComponent.field.showineditmode"/>
            <button class="wm-icon clear wms wms-clear" (click)="liveWidgetSettingsService.clearBinding(liveWidgetSettingsService.selectedComponent.field, 'showineditmode', true)"></button>
          </div>
          <button name="wm-bind-property-{{'showineditmode'}}"
                  (click)="liveWidgetSettingsService.openBindVariableDialog(liveWidgetSettingsService.selectedComponent, 'showineditmode', 'field')"
                  class="wms wms-link" title="{{locale.LABEL_BIND_VARIABLE}}"></button>
          <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_SHOW}}"
             class="wms wms-help"></i>
        </div>

        <!--Filter on Field.-->
        <div class="form-group app-composite-widget clearfix"
             *ngIf="liveWidgetSettingsService.activeWidgetScope.isBoundToLiveVariable && !liveWidgetSettingsService.selectedComponent.field.relatedEntityName">
          <label class="col-md-3 control-label app-label">{{locale.LABEL_WIDGET_DESIGNER_FILTER_ON_FIELD}}</label>
          <div class="form-control wms-typeahead-live-filter">
            <wms-typeahead placeholder="{{locale.LABEL_SEARCH_LIVE_FILTER_FIELD}}" name="wms-live-filter"
                           [model]="liveWidgetSettingsService.selectedComponent.field.filterOn"
                           [options]="liveWidgetSettingsService.filterFields"
                           (onSelect)="onFilterOnFieldSelected('filterOn', $event)"
                           [disable]="(liveWidgetSettingsService.selectedComponent.field.dataset || !liveWidgetSettingsService.isDatasetWidgets[liveWidgetSettingsService.selectedComponent.field.editWidgetType])? true:false"></wms-typeahead>
          </div>
          <i placement="right" [tooltipAppendToBody]="true"
             tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_FILTER_ON_FIELD}}" class="wms wms-help"></i>
        </div>


        <div
          *ngIf="liveWidgetSettingsService.activeWidgetScope.variable?.operation === 'read' && liveWidgetSettingsService.selectedComponent.field.relatedEntityName && !liveWidgetSettingsService.selectedComponent.field.dataset && liveWidgetSettingsService.isListWidget(liveWidgetSettingsService.selectedComponent.field.editWidgetType)">
          <!--Filter Criteria-->
          <!--            <wms-criteria-builder-->
          <!--              is-dialog="true"-->
          <!--              filter-fields="selectedFieldColumns"-->
          <!--              ng-model="selectedComponent.field.filterexpressions"-->
          <!--              on-change-callback="onChangeCallback(pNameObj)"-->
          <!--              on-bind-callback="onBindCallback(pNameObj, ruleObj)">-->
          <!--            </wms-criteria-builder>-->
        </div>

        <!--Validations-->

        <div
          *ngIf="liveWidgetSettingsService.selectedComponent.field.editWidgetType && liveWidgetSettingsService.selectedComponent.field.editWidgetType !== 'upload' && liveWidgetSettingsService.selectedComponent.field.editWidgetType !== 'Widget type for the field'  ">
          <h5 class="dialog-body-sub-heading">{{locale.LABEL_PROPERTYGROUP_VALIDATION}}</h5>

          <!--required-->
          <div class="form-group app-composite-widget clearfix">
            <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_REQUIRED}}</label>
            <wms-toggle [hideLabels]="true"
                        [id]="'required'+-+liveWidgetSettingsService.selectedComponent.field.required"
                        *ngIf="convertToString(liveWidgetSettingsService.selectedComponent.field.required).indexOf('bind:') !== 0"
                        [model]="liveWidgetSettingsService.selectedComponent.field.required"
                        (onChange)="toToggle('required',$event)"

            ></wms-toggle>
                        <div class="property-value bind-input-wrapper" *ngIf="convertToString(liveWidgetSettingsService.selectedComponent.field.required).indexOf('bind:') === 0">
                          <input type="text" class="form-control app-textbox bound-value bound-value-disable" [value]="liveWidgetSettingsService.selectedComponent.field.required" disabled
                                 wmsExpressionError [expression]="liveWidgetSettingsService.selectedComponent.field.required"
                                 [attr.title]="liveWidgetSettingsService.selectedComponent.field.required"/>
                          <button class="wm-icon clear wms wms-clear" (click)="liveWidgetSettingsService.clearBinding(liveWidgetSettingsService.selectedComponent.field, 'required')"></button>
                        </div>
            <button name="wm-bind-property-{{'required'}}"
                    (click)="liveWidgetSettingsService.openBindVariableDialog(liveWidgetSettingsService.selectedComponent, 'required', 'field')"
                    class="wms wms-link" title="{{locale.LABEL_BIND_VARIABLE}}"></button>
            <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_REQUIRED}}"
               class="wms wms-help"></i>
          </div>

          <!--maxchars-->
          <div class="form-group app-composite-widget clearfix"
               *ngIf="liveWidgetSettingsService.selectedComponent.field.editWidgetType === 'text' || liveWidgetSettingsService.selectedComponent.field.editWidgetType === 'textarea'">
            <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_MAXCHARS}}</label>
            <input class="form-control app-textbox"
                   [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.maxchars"
                   *ngIf="convertToString(liveWidgetSettingsService.selectedComponent.field.maxchars).indexOf('bind:') !== 0"
                   ng-model-options="{ updateOn: 'blur change'}">
                        <div class="property-value bind-input-wrapper" *ngIf="convertToString(liveWidgetSettingsService.selectedComponent.field.maxchars).indexOf('bind:') === 0">
                          <input type="text" class="form-control app-textbox bound-value bound-value-disable" [value]="liveWidgetSettingsService.selectedComponent.field.maxchars" disabled
                                 wmsExpressionError [expression]="liveWidgetSettingsService.selectedComponent.field.maxchars"
                                 [attr.title]="liveWidgetSettingsService.selectedComponent.field.maxchars"/>
                          <button class="wm-icon clear wms wms-clear" (click)="liveWidgetSettingsService.clearBinding(liveWidgetSettingsService.selectedComponent.field, 'maxchars')"></button>
                        </div>
            <button name="wm-bind-property-{{'maxchars'}}"
                    (click)="liveWidgetSettingsService.openBindVariableDialog(liveWidgetSettingsService.selectedComponent, 'maxchars', 'field')"
                    class="wms wms-link" title="{{locale.LABEL_BIND_VARIABLE}}"></button>
            <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PROPERTY_MAXCHARS}}"
               class="wms wms-help"></i>
          </div>

          <!--minvalue-->
          <div class="form-group app-composite-widget clearfix"
               *ngIf="liveWidgetSettingsService.selectedComponent.field.editWidgetType === 'number' || liveWidgetSettingsService.selectedComponent.field.editWidgetType === 'currency'">
            <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_MINVALUE}}</label>
            <input class="form-control app-textbox" type="number"
                   [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.minvalue"
                   *ngIf="convertToString(liveWidgetSettingsService.selectedComponent.field?.minvalue).indexOf('bind:') !== 0"
                   ng-model-options="{ updateOn: 'blur change'}">
                        <div class="property-value bind-input-wrapper" *ngIf="convertToString(liveWidgetSettingsService.selectedComponent.field.minvalue).indexOf('bind:') === 0">
                          <input type="text" class="form-control app-textbox bound-value bound-value-disable" [value]="liveWidgetSettingsService.selectedComponent.field.minvalue" disabled
                                 wmsExpressionError [expression]="liveWidgetSettingsService.selectedComponent.field.minvalue"
                                 [attr.title]="liveWidgetSettingsService.selectedComponent.field.minvalue"/>
                          <button class="wm-icon clear wms wms-clear" (click)="liveWidgetSettingsService.clearBinding(liveWidgetSettingsService.selectedComponent.field, 'minvalue')"></button>
                        </div>
            <button name="wm-bind-property-{{'minvalue'}}"
                    (click)="liveWidgetSettingsService.openBindVariableDialog(liveWidgetSettingsService.selectedComponent, 'minvalue', 'field')"
                    class="wms wms-link" title="{{locale.LABEL_BIND_VARIABLE}}"></button>
            <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PROPERTY_MINVALUE}}"
               class="wms wms-help"></i>
          </div>

          <!--maxvalue-->
          <div class="form-group app-composite-widget clearfix"
               *ngIf="liveWidgetSettingsService.selectedComponent.field.editWidgetType === 'number'  || liveWidgetSettingsService.selectedComponent.field.editWidgetType === 'currency'">
            <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_MAXVALUE}}</label>
            <input class="form-control app-textbox" type="number"
                   [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.maxvalue"
                   *ngIf="convertToString(liveWidgetSettingsService.selectedComponent.field?.maxvalue).indexOf('bind:') !== 0"
                   ng-model-options="{ updateOn: 'blur change'}">
                        <div class="property-value bind-input-wrapper" *ngIf="convertToString(liveWidgetSettingsService.selectedComponent.field.maxvalue).indexOf('bind:') === 0">
                          <input type="text" class="form-control app-textbox bound-value bound-value-disable" [value]="liveWidgetSettingsService.selectedComponent.field.maxvalue" disabled
                                 wmsExpressionError [expression]="liveWidgetSettingsService.selectedComponent.field.maxvalue"
                                 [attr.title]="liveWidgetSettingsService.selectedComponent.field.maxvalue"/>
                          <button class="wm-icon clear wms wms-clear" (click)="liveWidgetSettingsService.clearBinding(liveWidgetSettingsService.selectedComponent.field, 'maxvalue')"></button>
                        </div>
            <button name="wm-bind-property-{{'maxvalue'}}"
                    (click)="liveWidgetSettingsService.openBindVariableDialog(liveWidgetSettingsService.selectedComponent, 'maxvalue', 'field')"
                    class="wms wms-link" title="{{locale.LABEL_BIND_VARIABLE}}"></button>
            <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PROPERTY_MAXVALUE}}"
               class="wms wms-help"></i>
          </div>

          <!-- Currency, number widget step property -->
          <div class="form-group app-composite-widget clearfix"
               *ngIf="liveWidgetSettingsService.selectedComponent.field.editWidgetType === 'number' || liveWidgetSettingsService.selectedComponent.field.editWidgetType === 'currency'">
            <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_STEP}}</label>
            <input type="number"
                   class="form-control app-textbox"
                   title="{{liveWidgetSettingsService.selectedComponent.field.step}}"
                   [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.step"
                   [ngModelOptions]="{ updateOn: 'change'}">
            <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PROPERTY_STEP}}"
               class="wms wms-help"></i>
          </div>

          <!--regexp-->
          <div class="form-group app-composite-widget clearfix"
               *ngIf="liveWidgetSettingsService.selectedComponent.field.editWidgetType === 'text' || liveWidgetSettingsService.selectedComponent.field.editWidgetType === 'number'">
            <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_REGEXP}}</label>
            <input class="form-control app-textbox" type="text"
                   [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.regexp"
                   *ngIf="convertToString(liveWidgetSettingsService.selectedComponent.field.regexp).indexOf('bind:') !== 0"
                   ng-model-options="{ updateOn: 'blur change'}">
                        <div class="property-value bind-input-wrapper" *ngIf="convertToString(liveWidgetSettingsService.selectedComponent.field.regexp).indexOf('bind:') === 0">
                          <input type="text" class="form-control app-textbox bound-value bound-value-disable" [value]="liveWidgetSettingsService.selectedComponent.field.regexp" disabled
                                 wmsExpressionError [expression]="liveWidgetSettingsService.selectedComponent.field.regexp"
                                 [attr.title]="liveWidgetSettingsService.selectedComponent.field.regexp"/>
                          <button class="wm-icon clear wms wms-clear"  (click)="liveWidgetSettingsService.clearBinding(liveWidgetSettingsService.selectedComponent.field, 'regexp')"></button>
                        </div>
            <button name="wm-bind-property-{{'regexp'}}"
                    (click)="liveWidgetSettingsService.openBindVariableDialog(liveWidgetSettingsService.selectedComponent, 'regexp', 'field')"
                    class="wms wms-link" title="{{locale.LABEL_BIND_VARIABLE}}"></button>
            <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PROPERTY_REGEXP}}"
               class="wms wms-help"></i>
          </div>

          <!--validation message-->
          <div class="form-group app-composite-widget clearfix">
            <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_VALIDATIONMESSAGE}}</label>
            <input class="form-control app-textbox" type="text"
                   [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.validationmessage"
                   *ngIf="convertToString(liveWidgetSettingsService.selectedComponent.field.validationmessage).indexOf('bind:') !== 0"
                   ng-model-options="{ updateOn: 'blur change'}">
                        <div class="property-value bind-input-wrapper" *ngIf="convertToString(liveWidgetSettingsService.selectedComponent.field.validationmessage).indexOf('bind:') === 0">
                          <input type="text" class="form-control app-textbox bound-value bound-value-disable" [value]="liveWidgetSettingsService.selectedComponent.field.validationmessage" disabled
                                 wmsExpressionError [expression]="liveWidgetSettingsService.selectedComponent.field.validationmessage"
                                 [attr.title]="liveWidgetSettingsService.selectedComponent.field.validationmessage"/>
                          <button class="wm-icon clear wms wms-clear" (click)="liveWidgetSettingsService.clearBinding(liveWidgetSettingsService.selectedComponent.field, 'validationmessage')"></button>
                        </div>
            <button name="wm-bind-property-{{'validationmessage'}}"
                    (click)="liveWidgetSettingsService.openBindVariableDialog(liveWidgetSettingsService.selectedComponent, 'validationmessage', 'field')"
                    class="wms wms-link" title="{{locale.LABEL_BIND_VARIABLE}}"></button>
            <i placement="right" [tooltipAppendToBody]="true"
               tooltip="{{locale.MESSAGE_HELP_PROPERTY_VALIDATIONMESSAGE}}" class="wms wms-help"></i>
          </div>
        </div>

      </tab>


      <!--Export expression tab-->
      <tab
        *ngIf="liveWidgetSettingsService.shadowProperties.exportformat && (liveWidgetSettingsService.activeWidgetScope.isBoundToLiveVariable || liveWidgetSettingsService.activeWidgetScope.isBoundToFilter || liveWidgetSettingsService.activeWidgetScope.isBoundToQueryServiceVariable)"  style='padding-top:15px'>
        <ng-template tabHeading class="tab-heading">
          {{locale.LABEL_GRID_DESIGNER_EXPORT_OPTIONS}}
        </ng-template>

        <div class="form-group app-composite-widget clearfix display-value">
          <label class="col-md-3 control-label app-label">{{locale.LABEL_WIDGET_DESIGNER_VALUE_EXPRESSION}}</label>
          <textarea class="form-control app-textarea"
                    [attr.placeholder]="locale.PLACEHOLDER_DESIGNER_COLUMN_CUSTOM_EXPRESSION"
                    [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.exportexpression"
                    ng-model-options="{ updateOn: 'blur change' }"></textarea>
          <ul class="display-value-list">
            <li class="item clearfix" *ngFor="let column of fieldsList ;"
                (click)="liveWidgetSettingsService.populateDisplayValue(column, 'exportexpression')" title="{{column}}">
              <i class="wms wms-arrow-left"></i>
              <span class="item-name">{{column}}</span>
            </li>
          </ul>
          <i placement="right" [tooltipAppendToBody]="true"
             tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_EXPORT_EXPRESSION}}" class="wm-icon wms wms-help"></i>
        </div>


      </tab>

      <tab (selectTab)="liveWidgetSettingsService.selectPropertyGroup(liveWidgetSettingsService.propertyGroups[2]);"
           *ngIf="liveWidgetSettingsService.shadowProperties.filtermode"  style='padding-top:15px'>
        <ng-template tabHeading class="tab-heading">
          {{locale.LABEL_GRID_DESIGNER_FILTER_OPTIONS}}
        </ng-template>

        <div class="form-group app-composite-widget clearfix">
          <label class="col-md-3 control-label app-label">{{locale.LABEL_WIDGET_DESIGNER_SEARCHABLE}}</label>
          <wms-toggle [hideLabels]="true"
                      [contentEditable]="liveWidgetSettingsService.selectedComponent.field.type !== 'blob' && liveWidgetSettingsService.selectedComponent.field.type !== 'clob'"
                      [id]="'searchable'+-+liveWidgetSettingsService.selectedComponent.field.searchable"
                      [model]="liveWidgetSettingsService.selectedComponent.field.searchable"
                      [onValue]="true" [offValue]="false"
                      (onChange)="toToggle('searchable',$event)"></wms-toggle>
          <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_SEARCHABLE}}"
             class="wms wms-help"></i>
        </div>
        <div
          *ngIf="liveWidgetSettingsService.selectedComponent.field.searchable && liveWidgetSettingsService.shadowProperties.filtermode === 'multicolumn'">
          <div class="form-group app-composite-widget clearfix">
            <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_WIDGET}}</label>
            <select class="form-control app-textbox" scopedataset="filterWidgetOptions"
                    [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.filterwidget"
                    (change)="filterWidgetChange();">
              <option>{{locale.MESSAGE_PLACEHOLDER_FILTER_WIDGET_FOR_FIELD}}</option>
              <option *ngFor="let option of filterWidgetOptions" [value]="option">{{option}}</option>
            </select>
            <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.LABEL_WIDGET_DESIGNER_WIDGET_TYPE}}"
               class="wms wms-help"></i>
          </div>

          <div class="form-group app-composite-widget clearfix"
               *ngIf="liveWidgetSettingsService.selectedComponent.field.filterwidget === 'text'">
            <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_INPUTTYPE}}</label>
            <select class="form-control app-textbox" scopedataset="textInputTypeOptions"
                    [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.filterinputtype">
              <option *ngFor="let option of textInputTypeOptions" [value]="option">{{option}}</option>
            </select>
            <i [tooltipAppendToBody]="true" placement="right" tooltip="{{locale.MESSAGE_HELP_PROPERTY_INPUTTYPE}}"
               class="wms wms-help"></i>
          </div>

          <div class="form-group app-composite-widget clearfix">
            <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_PLACEHOLDER}}</label>
            <input class="form-control app-textbox"
                   [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.filterplaceholder"/>
            <i [tooltipAppendToBody]="true" placement="right" tooltip="{{locale.MESSAGE_HELP_PROPERTY_SEARCHLABEL}}"
               class="wms wms-help"></i>
          </div>

          <div
            *ngIf="liveWidgetSettingsService.isDatasetWidgets[liveWidgetSettingsService.selectedComponent.field.filterwidget]">
            <div class="form-group app-composite-widget clearfix">
              <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTYGROUP_DATASET}}</label>
              <input  class="form-control app-textbox" [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.filterdataset" *ngIf="convertToString(liveWidgetSettingsService.selectedComponent.field.filterdataset).indexOf('bind:') !== 0">
                            <div class="bind-input-wrapper" *ngIf="convertToString(liveWidgetSettingsService.selectedComponent.field.filterdataset).indexOf('bind:') === 0">
                              <input type="text" class="form-control app-textbox bound-value bound-value-disable" disabled [value]="liveWidgetSettingsService.selectedComponent.field.filterdataset"
                                     wmsExpressionError [expression]="liveWidgetSettingsService.selectedComponent.field.filterdataset"
                                     [attr.title]="liveWidgetSettingsService.selectedComponent.field.filterdataset"/>
                              <button class="wm-icon clear wms wms-clear" (click)="liveWidgetSettingsService.clearBinding(liveWidgetSettingsService.selectedComponent.field, 'filterdataset')"></button>
                            </div>
              <button
                (click)="liveWidgetSettingsService.openBindVariableDialog(liveWidgetSettingsService.selectedComponent, 'filterdataset', 'field')"
                class="wms wms-link" title="{{locale['LABEL_BIND_VARIABLE']}}"></button>
              <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PROPERTY_DATASET}}"
                 class="wms wms-help"></i>
            </div>

            <!--Datafield, display field and search key-->
            <div
              *ngIf="liveWidgetSettingsService.selectedComponent.field.filterdataset || filterDisplayfieldArray.length">
              <div class="form-group app-composite-widget clearfix"
                   *ngIf="liveWidgetSettingsService.selectedComponent.field.filterwidget === 'autocomplete'">
                <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_DISPLAYLABEL}}</label>
                <select class="form-control app-textbox" scopedataset="filterDisplayfieldArray"
                        [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.filterdisplaylabel">
                  <option *ngFor="let option of filterDisplayfieldArray;" [value]="option">{{option}}</option>
                </select>
                <i placement="right" [tooltipAppendToBody]="true"
                   tooltip="{{locale.MESSAGE_HELP_PROPERTY_DISPLAYLABEL}}" class="wms wms-help"></i>
              </div>
              <div class="form-group app-composite-widget clearfix"
                   *ngIf="liveWidgetSettingsService.selectedComponent.field.filterwidget === 'autocomplete'">
                <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_SEARCHKEY}}</label>
                <wm-checkboxset [datavalue]="liveWidgetSettingsService.selectedComponent.field.filtersearchkey"
                                [dataset]="filterDisplayfieldArray"
                                (onChange)="handelChangesFilterSearchKey($event.value)"
                ></wm-checkboxset>
                <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PROPERTY_SEARCHKEY}}"
                   class="wms wms-help"></i>
              </div>
              <div class="form-group app-composite-widget clearfix">
                <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_DATAFIELD}}</label>
                <select class="form-control app-textbox" scopedataset="filterDatafieldArray"
                        [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.filterdatafield">
                  <option *ngFor="let option of filterDatafieldArray;" [value]="option">{{option}}</option>
                </select>
                <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PROPERTY_DATAFIELD}}"
                   class="wms wms-help"></i>
              </div>
              <div class="form-group app-composite-widget clearfix"
                   *ngIf="liveWidgetSettingsService.selectedComponent.field.filterwidget === 'select'">
                <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_DISPLAYFIELD}}</label>
                <select class="form-control app-textbox" scopedataset="filterDisplayfieldArray"
                        [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.filterdisplayfield">
                  <option *ngFor="let option of filterDisplayfieldArray;" [value]="option">{{option}}</option>
                </select>
                <i placement="right" [tooltipAppendToBody]="true"
                   tooltip="{{locale.MESSAGE_HELP_PROPERTY_DISPLAYFIELD}}" class="wms wms-help"></i>
              </div>
            </div>
          </div>
          <!--Filter on Field.-->
          <div class="form-group app-composite-widget clearfix"
               *ngIf="liveWidgetSettingsService.activeWidgetScope.isBoundToLiveVariable && !liveWidgetSettingsService.selectedComponent.field.relatedEntityName">
            <label class="col-md-3 control-label app-label">{{locale.LABEL_WIDGET_DESIGNER_FILTER_ON_FIELD}}</label>
            <div class="form-control wms-typeahead-live-filter">
              <wms-typeahead placeholder="{{locale.LABEL_SEARCH_LIVE_FILTER_FIELD}}" name="wms-live-filter"
                             [model]="liveWidgetSettingsService.selectedComponent.field.filteronfilter"
                             [options]="liveWidgetSettingsService.filterFields"
                             (onSelect)="onFilterOnFieldSelected('filteronfilter',$event)"
                             [disable]="liveWidgetSettingsService.selectedComponent.field.filterdataset || !liveWidgetSettingsService.isDatasetWidgets[liveWidgetSettingsService.selectedComponent.field.filterwidget]"></wms-typeahead>
            </div>
            <i placement="right" [tooltipAppendToBody]="true"
               tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_FILTER_ON_FIELD}}" class="wms wms-help"></i>
          </div>


        </div>


      </tab>

    </tabset>


  </div>
  <!--For group headers-->
  <div *ngIf="liveWidgetSettingsService.selectedComponent.field.isGroup" class="dialog-form-section">
    <!--Title-->
    <div class="form-group app-composite-widget clearfix">
      <label class="col-md-3 control-label app-label">{{locale.LABEL_WIDGET_DESIGNER_TITLE}}</label>
      <input class="form-control app-textbox"
             [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.displayName"
             (ngModelChange)="onDisplayNameChange()"
             [ngModelOptions]="{ updateOn: 'blur' }"
             *ngIf="convertToString(liveWidgetSettingsService.selectedComponent.field.displayName).indexOf('bind:') !== 0"
             placeholder="{{locale.PLACEHOLDER_DESIGNER_COLUMN_TITLE}}"/>
      <div class="bind-input-wrapper"
           *ngIf="convertToString(liveWidgetSettingsService.selectedComponent.field.displayName).indexOf('bind:') === 0">
        <input type="text"
               class="form-control app-textbox bound-value bound-value-disable" disabled
               [value]="liveWidgetSettingsService.selectedComponent.field.displayName"
               wmsExpressionError [expression]="liveWidgetSettingsService.selectedComponent.field.displayName"
               [attr.title]="liveWidgetSettingsService.selectedComponent.field.displayName"/>
        <button class="wm-icon clear wms wms-clear"
                (click)="liveWidgetSettingsService.clearBinding(liveWidgetSettingsService.selectedComponent.field, 'displayName')"></button>
      </div>
      <button
        (click)="liveWidgetSettingsService.openBindVariableDialog(liveWidgetSettingsService.selectedComponent ,'displayName', 'field')"
        [disabled]="liveWidgetSettingsService.activeWidgetScope.widgetProps['displayName']?.disabled"
        class="wms wms-link" title="{{locale['LABEL_BIND_VARIABLE']}}"></button>
      <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_TITLE}}"
         class="wms wms-help"></i>
    </div>
    <div class="form-group app-composite-widget clearfix">
      <label class="col-md-3 control-label app-label">{{locale.LABEL_WIDGET_DESIGNER_WIDGET_GROUP}}</label>
      <wms-typeahead class="col-md-5" name="wms-select-group"
                     [placeholder]="locale.MESSAGE_PLACEHOLDER_WIDGET_DESIGNER_WIDGET_GROUP"
                     [model]="liveWidgetSettingsService.selectedComponent.field.parentGroup"
                     [options]="groupList"
                     (onSelect)="changeGroups(liveWidgetSettingsService.selectedComponent.field?.parentGroup, $event)"
                     (onClear)="changeGroups(liveWidgetSettingsService.selectedComponent.field?.parentGroup, undefined)"
                     propertyName="displayName"></wms-typeahead>
      <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_GROUP}}"
         class="wms wms-help"></i>
    </div>
  </div>


</div>


<ng-template #advancedTemplate>
  <!--Widget-type-->
  <div class="form-group app-composite-widget clearfix">
    <label class="col-md-3 control-label app-label">{{locale.LABEL_WIDGET_DESIGNER_WIDGET}}</label>
    <select class="form-control app-select" [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.widgetType" data-identifier="property-widget" (change)="resetDefaultWidgetConfig()">
      <option value=undefined  >{{locale.LABEL_WIDGET_DESIGNER_SELECT_A_WIDGET}}</option>
      <option *ngFor="let value of  liveWidgetSettingsService.widgetTypes " [value]="value">{{value}}</option>
    </select>
    <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_WIDGET}}"
       class="wm-icon wms wms-help"></i>
  </div>

  <div *ngIf="liveWidgetSettingsService.selectedComponent.field.widgetType    &&  liveWidgetSettingsService.selectedComponent.field.widgetType !== 'undefined'">
    <div class="form-group app-composite-widget clearfix"  >
      <label class="col-md-3 control-label app-label">{{locale.LABEL_WIDGET_DESIGNER_WIDGET_CLASS}}</label>
      <input class="form-control app-textbox"
             [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.widgetConfig.class"
             placeholder="{{locale.PLACEHOLDER_DESIGNER_IMAGE_WIDGET_CLASS}}"
             (change)="liveWidgetSettingsService.updateCustomExpression()" data-identifier="property-widgetclass"/>
      <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_WIDGET_CLASS}}"
         class="wm-icon wms wms-help"></i>
    </div>
    <div class="form-group app-composite-widget clearfix">
      <label class="col-md-3 control-label app-label">{{locale.LABEL_WIDGET_DESIGNER_WIDGET_CONDITIONAL_CLASS}}</label>
      <div class="conditional-classes-container">
        <div
          *ngFor="let cls of liveWidgetSettingsService.selectedComponent.field.widgetConfig.ngClasses ; let First = first; let Last = last">
          <input type="text" [(ngModel)]="cls.className" ng-model-options="{debounce:300}"
                 class="form-control app-textbox conditional-classname" [ngClass]="{'error': cls.error?.class}"
                 placeholder="{{locale.LABEL_CLASS_NAME}}"
                 (ngModelChange)="liveWidgetSettingsService.validateAndUpdateExpression(cls);" data-identifier="property-conditionalclassname"/>
          <input type="text" [(ngModel)]="cls.condition" ng-model-options="{debounce:300}"
                 [ngClass]="{'error': cls.error?.condition}"
                 class="form-control app-textbox conditional-expression"
                 placeholder="{{locale.PLACEHOLDER_DESIGNER_CONDITION_EXPRESSION}}"
                 (change)="liveWidgetSettingsService.validateAndUpdateExpression(cls);" data-identifier="property-conditionalclassexpression"/>
          <button type="button" title="{{locale.LABEL_WIDGET_DESIGNER_REMOVE_CONDITION}}"
                  class="btn btn-secondary conditional-class-remove-btn"
                  (click)="liveWidgetSettingsService.removeConditionalClass('widget',cls)">
            <i class="wm-icon wms wms-delete"></i>
          </button>
          <button type="button" title="{{locale.LABEL_WIDGET_DESIGNER_ADD_CONDITIONAL_CLASS}}"
                  class="btn btn-secondary conditional-class-add-btn"
                  *ngIf="Last"
                  (click)="liveWidgetSettingsService.addConditionalClass(cls, liveWidgetSettingsService.selectedComponent.field.widgetConfig)">
            <i class="wm-icon wms wms-plus"></i>
          </button>
          <i placement="right" [tooltipAppendToBody]="true"
             tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_WIDGET_CONDITIONAL_CLASS}}"
             class="wm-icon wms wms-help" *ngIf="First"></i>
          <p class="row help-block error" *ngIf="cls.errorMsg">{{cls.errorMsg}}</p>
        </div>
      </div>
    </div>

    <div class="form-group app-composite-widget clearfix">
      <label class="col-md-3 control-label app-label">{{locale.LABEL_WIDGET_DESIGNER_WIDGET_CONDITIONAL_STYLE}}</label>
            <div class="property-value bind-input-wrapper" *ngIf="convertToString(liveWidgetSettingsService.selectedComponent.field.widgetConfig.conditionalstyle).indexOf('bind:') === 0">
              <input type="text" class="form-control app-textbox bound-value bound-value-disable" [value]="liveWidgetSettingsService.selectedComponent.field.widgetConfig.conditionalstyle" [readonly]="true"
                     wmsExpressionError [expression]="liveWidgetSettingsService.selectedComponent.field.widgetConfig.conditionalstyle"
                     [attr.title]="liveWidgetSettingsService.selectedComponent.field.widgetConfig.conditionalstyle" data-identifier="property-conditionalstyle"/>
              <button class="wm-icon clear wms wms-clear" (click)="liveWidgetSettingsService.clearBinding(liveWidgetSettingsService.selectedComponent.field.widgetConfig, 'conditionalstyle', '', 'tableColumn')"></button>
            </div>
      <button name="wm-bind-property-{{'conditionalstyle'}}"
              (click)="liveWidgetSettingsService.openBindVariableDialog(liveWidgetSettingsService.selectedComponent.field, 'conditionalstyle', 'widgetConfig', 'tableColumn', 'expression')"
              class="wms wms-link" title="{{locale.LABEL_BIND_VARIABLE}}"></button>
      <i placement="right" [tooltipAppendToBody]="true"
         tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_WIDGET_CONDITIONAL_STYLE}}" class="wms wms-help"></i>
    </div>
  </div>

  <div *ngIf="liveWidgetSettingsService.selectedComponent.field.widgetType === 'image'">
    <div class="form-group app-composite-widget clearfix">
      <label class="col-md-3 control-label app-label">{{locale.LABEL_WIDGET_DESIGNER_WIDGET_SRC}}</label>
      <input class="form-control app-textbox"
             [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.widgetConfig.src"
             *ngIf="convertToString(liveWidgetSettingsService.selectedComponent.field.widgetConfig.src).indexOf('bind:') !== 0"
             placeholder="{{locale.PLACEHOLDER_DESIGNER_IMAGE_WIDGET_SRC}}"
             (change)="liveWidgetSettingsService.updateCustomExpression()"/>
            <div class="property-value bind-input-wrapper" *ngIf="convertToString(liveWidgetSettingsService.selectedComponent.field.widgetConfig.src).indexOf('bind:') === 0">
              <input type="text" class="form-control app-textbox bound-value bound-value-disable" [value]="liveWidgetSettingsService.selectedComponent.field.widgetConfig.src" [readonly]="true"
                     wmsExpressionError [expression]="liveWidgetSettingsService.selectedComponent.field.widgetConfig.src"
                     [attr.title]="liveWidgetSettingsService.selectedComponent.field.widgetConfig.src" data-identifier="property-imagesource"/>
              <button class="wm-icon clear wms wms-clear" (click)="liveWidgetSettingsService.clearBinding(liveWidgetSettingsService.selectedComponent.field.widgetConfig, 'src', '', 'tableColumn')"></button>
            </div>
      <button name="wm-bind-property-{{'src'}}"
              (click)="liveWidgetSettingsService.openBindVariableDialog(liveWidgetSettingsService.selectedComponent.field, 'src', 'widgetConfig', 'tableColumn')"
              class="wms wms-link" title="{{locale.LABEL_BIND_VARIABLE}}"></button>
      <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.LABEL_WIDGET_DESIGNER_WIDGET_SRC}}"
         class="wm-icon wms wms-help"></i>
    </div>
  </div>
  <div
    *ngIf="liveWidgetSettingsService.selectedComponent.field.widgetType && liveWidgetSettingsService.selectedComponent.field.widgetType !== 'checkbox' && liveWidgetSettingsService.selectedComponent.field.widgetType !== 'image'   &&  liveWidgetSettingsService.selectedComponent.field.widgetType !== 'undefined'">
    <div class="form-group app-composite-widget clearfix">
      <label class="col-md-3 control-label app-label">{{locale.LABEL_WIDGET_DESIGNER_WIDGET_TITLE}}</label>
      <input class="form-control app-textbox"
             [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.widgetConfig.title"
             *ngIf="liveWidgetSettingsService.selectedComponent.field.widgetType !== 'label'"
             placeholder="{{locale.PLACEHOLDER_DESIGNER_WIDGET_LABEL}}"
             (change)="liveWidgetSettingsService.updateCustomExpression()" data-identifier="property-widgettitle"/>
      <div class="property-value bind-input-wrapper"
           *ngIf="liveWidgetSettingsService.selectedComponent.field.widgetType === 'label'">
        <input type="text" class="form-control app-textbox bound-value bound-value-disable"
               *ngIf="convertToString(liveWidgetSettingsService.selectedComponent.field.widgetConfig.title).indexOf('bind:') !== 0"
               wmsExpressionError [expression]="liveWidgetSettingsService.selectedComponent.field.widgetConfig.title"
               [value]="liveWidgetSettingsService.selectedComponent.field.widgetConfig.title"
               [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.widgetConfig.title"
               (change)="liveWidgetSettingsService.updateCustomExpression()"
               [attr.title]="liveWidgetSettingsService.selectedComponent.field.widgetConfig.title" data-identifier="property-widgettitle"/>
        <input type="text"
               class="form-control app-textbox bound-value bound-value-disable"
               *ngIf="convertToString(liveWidgetSettingsService.selectedComponent.field.widgetConfig.title).indexOf('bind:') === 0"
               wmsExpressionError [expression]="liveWidgetSettingsService.selectedComponent.field.widgetConfig.title"
               [value]="liveWidgetSettingsService.selectedComponent.field.widgetConfig.title"
               [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.widgetConfig.title"
               (change)="liveWidgetSettingsService.updateCustomExpression()"
               [readonly]="true"
               [attr.title]="liveWidgetSettingsService.selectedComponent.field.widgetConfig.title"/>


        <button class="wm-icon clear wms wms-clear"
                *ngIf="convertToString(liveWidgetSettingsService.selectedComponent.field.widgetConfig.title).indexOf('bind:') === 0"
                (click)="liveWidgetSettingsService.clearBinding(liveWidgetSettingsService.selectedComponent.field.widgetConfig, 'title', '', 'tableColumn')"></button>
      </div>
      <button name="wm-bind-property-{{'title'}}"
              *ngIf="liveWidgetSettingsService.selectedComponent.field.widgetType === 'label'"
              (click)="liveWidgetSettingsService.openBindVariableDialog(liveWidgetSettingsService.selectedComponent.field, 'title', 'widgetConfig', 'tableColumn')"
              class="wms wms-link" title="{{locale.LABEL_BIND_VARIABLE}}"></button>
      <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_TITLE}}"
         class="wm-icon wms wms-help"></i>
    </div>
  </div>

  <div *ngIf="liveWidgetSettingsService.selectedComponent.field.widgetType === 'anchor'">
    <div class="form-group app-composite-widget clearfix">
      <label class="col-md-3 control-label app-label">{{locale.LABEL_WIDGET_DESIGNER_WIDGET_HYPERLINK}}</label>
      <input class="form-control app-textbox"
             [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.widgetConfig.hyperlink"
             *ngIf="convertToString(liveWidgetSettingsService.selectedComponent.field.widgetConfig.hyperlink).indexOf('bind:') !== 0"
             placeholder="{{locale.PLACEHOLDER_DESIGNER_IMAGE_WIDGET_HYPERLINK}}"
             (change)="liveWidgetSettingsService.updateCustomExpression()" data-identifier="property-widgethyperlink"/>
      <div class="property-value bind-input-wrapper"
           *ngIf="convertToString(liveWidgetSettingsService.selectedComponent.field.widgetConfig.hyperlink).indexOf('bind:') === 0">
        <input type="text"
               class="form-control app-textbox bound-value bound-value-disable" [readonly]="true"
               wmsExpressionError [expression]="liveWidgetSettingsService.selectedComponent.field.widgetConfig.hyperlink"
               [value]="liveWidgetSettingsService.selectedComponent.field.widgetConfig.hyperlink"
               [attr.title]="liveWidgetSettingsService.selectedComponent.field.widgetConfig.hyperlink" data-identifier="property-widgethyperlink"/>
        <button class="wm-icon clear wms wms-clear"
                (click)="liveWidgetSettingsService.clearBinding(liveWidgetSettingsService.selectedComponent.field.widgetConfig, 'hyperlink', '', 'tableColumn')"></button>
      </div>
      <button name="wm-bind-property-{{'hyperlink'}}"
              (click)="liveWidgetSettingsService.openBindVariableDialog(liveWidgetSettingsService.selectedComponent.field, 'hyperlink', 'widgetConfig', 'tableColumn')"
              class="wms wms-link" title="{{locale.LABEL_BIND_VARIABLE}}"></button>
      <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.LABEL_WIDGET_DESIGNER_WIDGET_HYPERLINK}}"
         class="wm-icon wms wms-help"></i>
    </div>
  </div>

  <div class="form-group app-composite-widget clearfix"
       *ngIf="liveWidgetSettingsService.selectedComponent.field.widgetType === 'button' || liveWidgetSettingsService.selectedComponent.field.widgetType === 'icon'">
    <label class="control-label property-label col-md-3">{{locale.LABEL_WIDGET_DESIGNER_WIDGET_ICONNAME}}</label>
    <div class="select-icon-class input-group"
         [ngClass]="{'bindable':liveWidgetSettingsService.selectedComponent.field.widgetType === 'icon'}">
            <span class="input-group-addon"
                  (click)="liveWidgetSettingsService.openIconChooserDialog(liveWidgetSettingsService.selectedComponent.field.widgetConfig)">
                <i
                  [ngClass]="liveWidgetSettingsService.selectedComponent.field.widgetConfig.icon || 'wms wms-search'"></i>
            </span>
      <input class="form-control app-textbox"
             [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.widgetConfig.icon"
             *ngIf="liveWidgetSettingsService.selectedComponent.field.widgetType !== 'icon'"
             placeholder="{{locale.PLACEHOLDER_DESIGNER_BUTTON_ICON}}"
             (change)="liveWidgetSettingsService.updateCustomExpression()" data-identifier="property-widgeticon"/>
      <div class="property-value bind-input-wrapper"
           *ngIf="liveWidgetSettingsService.selectedComponent.field.widgetType === 'icon'">
        <input type="text" class="form-control app-textbox bound-value bound-value-disable"
               *ngIf="convertToString(liveWidgetSettingsService.selectedComponent.field.widgetConfig.icon).indexOf('bind:') !== 0"
               [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.widgetConfig.icon"
               (change)="liveWidgetSettingsService.updateCustomExpression()"
               wmsExpressionError [expression]="liveWidgetSettingsService.selectedComponent.field.widgetConfig.icon"
               [value]="liveWidgetSettingsService.selectedComponent.field.widgetConfig.icon"
               [attr.title]="liveWidgetSettingsService.selectedComponent.field.widgetConfig.icon" data-identifier="property-widgeticon"/>
        <input type="text"
               class="form-control app-textbox bound-value bound-value-disable"
               *ngIf="convertToString(liveWidgetSettingsService.selectedComponent.field.widgetConfig.icon).indexOf('bind:') === 0"
               [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.widgetConfig.icon"
               (change)="liveWidgetSettingsService.updateCustomExpression()"
               wmsExpressionError [expression]="liveWidgetSettingsService.selectedComponent.field.widgetConfig.icon"
               [value]="liveWidgetSettingsService.selectedComponent.field.widgetConfig.icon"
               [readonly]="true"
               [attr.title]="liveWidgetSettingsService.selectedComponent.field.widgetConfig.icon" data-identifier="property-widgeticon"/>

        <button class="wm-icon clear wms wms-clear"
                *ngIf="convertToString(liveWidgetSettingsService.selectedComponent.field.widgetConfig.icon).indexOf('bind:') === 0"
                (click)="liveWidgetSettingsService.clearBinding(liveWidgetSettingsService.selectedComponent.field.widgetConfig, 'icon', '', 'tableColumn')"></button>
      </div>
      <button name="wm-bind-property-{{'icon'}}"
              *ngIf="liveWidgetSettingsService.selectedComponent.field.widgetType === 'icon'"
              (click)="liveWidgetSettingsService.openBindVariableDialog(liveWidgetSettingsService.selectedComponent.field, 'icon', 'widgetConfig', 'tableColumn')"
              class="wms wms-link" title="{{locale.LABEL_BIND_VARIABLE}}"></button>
    </div>
    <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_ICONNAME}}"
       class="wm-icon wms wms-help"></i>
  </div>
  <div class="form-group app-composite-widget clearfix"
       *ngIf="liveWidgetSettingsService.selectedComponent.field.widgetType === 'icon'">
    <label class="control-label property-label col-md-3">{{locale.LABEL_PROPERTY_ICONPOSITION}}</label>
    <select class="form-control app-select"
            [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.widgetConfig.iconposition"
            (change)="liveWidgetSettingsService.updateCustomExpression()" data-identifier="property-widgeticonposition">
      <option value="left">Left</option>
      <option value="right">Right</option>
    </select>
    <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PROPERTY_ICONPOSITION}}"
       class="wm-icon wms wms-help"></i>
  </div>

  <div class="form-group app-composite-widget clearfix"
       *ngIf="liveWidgetSettingsService.selectedComponent.field.widgetType === 'button'">
    <label class="col-md-3 control-label app-label">{{locale.LABEL_WIDGET_DESIGNER_WIDGET_ACTION}}</label>
    <div class="col-sm-7 event-input-column">
      <wms-event-handler [eventExpr]="liveWidgetSettingsService.selectedComponent.field.widgetConfig.action"
                         class="event-handler-parent"
                         (onChange)="liveWidgetSettingsService.onEventChange(liveWidgetSettingsService.selectedComponent.field, $event, 'field', true)"
                         (onNavigateAction)="liveWidgetSettingsService.saveDesignerSettings(true, $event)"
                         [eventOptions]="liveWidgetSettingsService.eventOptions" data-identifier="property-widgetaction"></wms-event-handler>
    </div>
    <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_ACTION}}"
       class="wm-icon wms wms-help"></i>
  </div>
  <div *ngIf="liveWidgetSettingsService.selectedComponent.field.widgetType === 'checkbox'">
    <div class="form-group app-composite-widget clearfix">
      <label class="col-md-3 control-label app-label">{{locale.LABEL_WIDGET_DESIGNER_WIDGET_DISABLE}}</label>
      <input class="form-control app-textbox"
             [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.widgetConfig.disabled"
             *ngIf="convertToString(liveWidgetSettingsService.selectedComponent.field.widgetConfig.disabled).indexOf('bind:') !== 0"
             placeholder="{{locale.PLACEHOLDER_DESIGNER_CHECKBOX_DISABLE}}"
             (change)="liveWidgetSettingsService.updateCustomExpression()" data-identifier="property-disable"/>
      <div class="property-value bind-input-wrapper"
           *ngIf="convertToString(liveWidgetSettingsService.selectedComponent.field.widgetConfig.disabled).indexOf('bind:') === 0">
        <input type="text"
               class="form-control app-textbox bound-value bound-value-disable" [readonly]="true"
               wmsExpressionError [expression]="liveWidgetSettingsService.selectedComponent.field.widgetConfig.disabled"
               value="{{liveWidgetSettingsService.selectedComponent.field.widgetConfig.disabled}}"
               [attr.title]="liveWidgetSettingsService.selectedComponent.field.widgetConfig.disabled" data-identifier="property-disable"/>
        <button class="wm-icon clear wms wms-clear"
                (click)="liveWidgetSettingsService.clearBinding(liveWidgetSettingsService.selectedComponent.field.widgetConfig, 'disabled', '', 'tableColumn')"></button>
      </div>
      <button name="wm-bind-property-{{'disabled'}}"
              (click)="liveWidgetSettingsService.openBindVariableDialog(liveWidgetSettingsService.selectedComponent.field, 'disabled', 'widgetConfig', 'tableColumn')"
              class="wms wms-link" title="{{locale.LABEL_BIND_VARIABLE}}"></button>
      <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_DISABLE}}"
         class="wm-icon wms wms-help"></i>
    </div>
  </div>


  <!--Value Expression-->
  <div class="form-group app-composite-widget clearfix">
    <label class="col-md-3 control-label app-label">{{locale.LABEL_WIDGET_DESIGNER_VALUE_EXPRESSION}}</label>
    <div class="col-md-9">
            <textarea class="form-control app-textarea expression-box"
                      [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.customExpression"
                      placeholder="{{locale.PLACEHOLDER_DESIGNER_COLUMN_CUSTOM_EXPRESSION}}"
                      (change)="liveWidgetSettingsService.onExpressionChange()" data-identifier="property-valueexpression"></textarea>
      <i placement="right" [tooltipAppendToBody]="true"
         tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_VALUE_EXPRESSION}}" class="wm-icon wms wms-help"></i>
      <span class="error"></span>
    </div>
  </div>


</ng-template>

